import adminLogin from "./adminLogin";
import approveAccountDeletionRequest from "./approveAccountDeletionRequest";
import approveCommercialOpportunityRequest from "./approveCommercialOpportunityRequest";
import approveCompanyUpdateRequest from "./approveCompanyUpdateRequest";
import approveProfileUpdateRequest from "./approveProfileUpdateRequest";
import batchCreateDriveFolderHierarchy from "./batchCreateDriveFolderHierarchy";
import cancelSubEvent from "./cancelSubEvent";
import changeMail from "./changeMail";
import changePassword from "./changePassword";
import checkVersion from "./checkVersion";
import createAnnouncement from "./createAnnouncement";
import createBoardMember from "./createBoardMember";
import createCompanyForAdmin from "./createCompanyForAdmin";
import createDriveFolder from "./createDriveFolder";
import createDriveRecord from "./createDriveRecord";
import createEvent from "./createEvent";
import createForm from "./createForm";
import createNews from "./createNews";
import createNewsCategory from "./createNewsCategory";
import createOldPresident from "./createOldPresident";
import createSubEvent from "./createSubEvent";
import createSystemLocale from "./createSystemLocale";
import deleteAnnouncement from "./deleteAnnouncement";
import deleteBoardMember from "./deleteBoardMember";
import deleteContactForm from "./deleteContactForm";
import deleteDriveFile from "./deleteDriveFile";
import deleteDriveFolder from "./deleteDriveFolder";
import deleteEvent from "./deleteEvent";
import deleteForm from "./deleteForm";
import deleteNews from "./deleteNews";
import deleteNewsCategory from "./deleteNewsCategory";
import deleteOldPresident from "./deleteOldPresident";
import deleteSentNotification from "./deleteSentNotification";
import deleteSubEvent from "./deleteSubEvent";
import deleteSystemLocale from "./deleteSystemLocale";
import deleteUser from "./deleteUser";
import duplicateFormForAdmin from "./duplicateFormForAdmin";
import editEvent from "./editEvent";
import editForm from "./editForm";
import editSubEvent from "./editSubEvent";
import endEventApplication from "./endEventApplication";
import executeCommand from "./executeCommand";
import finishEvent from "./finishEvent";
import getAllAccountDeletionRequestHistories from "./getAllAccountDeletionRequestHistories";
import getAllAccountDeletionRequests from "./getAllAccountDeletionRequests";
import getAllAnnouncements from "./getAllAnnouncements";
import getAllBoardMembers from "./getAllBoardMembers";
import getAllCommercialOpportunityRequestHistories from "./getAllCommercialOpportunityRequestHistories";
import getAllCommercialOpportunityRequests from "./getAllCommercialOpportunityRequests";
import getAllCompaniesForAdmin from "./getAllCompaniesForAdmin";
import getAllCompanyUpdateRequestHistories from "./getAllCompanyUpdateRequestHistories";
import getAllCompanyUpdateRequests from "./getAllCompanyUpdateRequests";
import getAllContactForms from "./getAllContactForms";
import getAllDriveFiles from "./getAllDriveFiles";
import getAllDriveFolders from "./getAllDriveFolders";
import getAllEventsForAdmin from "./getAllEventsForAdmin";
import getAllFormsForAdmin from "./getAllFormsForAdmin";
import getAllGenericInfo from "./getAllGenericInfo";
import getAllNews from "./getAllNews";
import getAllNewsCategories from "./getAllNewsCategories";
import getAllOldPresidents from "./getAllOldPresidents";
import getAllProfileUpdateRequestHistories from "./getAllProfileUpdateRequestHistories";
import getAllProfileUpdateRequests from "./getAllProfileUpdateRequests";
import getAllSentMails from "./getAllSentMails";
import getAllSentNotifications from "./getAllSentNotifications";
import getAllSubEventsForAdmin from "./getAllSubEventsForAdmin";
import getAllSystemLocales from "./getAllSystemLocales";
import getAllUsersForAdmin from "./getAllUsersForAdmin";
import getAnnouncementById from "./getAnnouncementById";
import getCities from "./getCities";
import getCommercialOpportunityRequest from "./getCommercialOpportunityRequest";
import getCompanyForAdmin from "./getCompanyForAdmin";
import getCompanyUpdateRequest from "./getCompanyUpdateRequest";
import getDashboardOverview from "./getDashboardOverview";
import getDepartments from "./getDepartments";
import getDistricts from "./getDistricts";
import getDriveItems from "./getDriveItems";
import getEventForAdmin from "./getEventForAdmin";
import getFaculties from "./getFaculties";
import getFormAnswersForAdmin from "./getFormAnswersForAdmin";
import getFormForAdmin from "./getFormForAdmin";
import getGenericInfoByKey from "./getGenericInfoByKey";
import getInitialConfigs from "./getInitialConfigs";
import getNewsById from "./getNewsById";
import getPositions from "./getPositions";
import getPresident from "./getPresident";
import getProfile from "./getProfile";
import getProfileUpdateRequest from "./getProfileUpdateRequest";
import getSectors from "./getSectors";
import getSentMailById from "./getSentMailById";
import getSentNotificationById from "./getSentNotificationById";
import getSubEventForAdmin from "./getSubEventForAdmin";
import getUniversities from "./getUniversities";
import getUploadTokenForAnnouncementCover from "./getUploadTokenForAnnouncementCover";
import getUploadTokenForAnnouncementPhoto from "./getUploadTokenForAnnouncementPhoto";
import getUploadTokenForCompanyPhoto from "./getUploadTokenForCompanyPhoto";
import getUploadTokenForContentPhoto from "./getUploadTokenForContentPhoto";
import getUploadTokenForDrive from "./getUploadTokenForDrive";
import getUploadTokenForEventCover from "./getUploadTokenForEventCover";
import getUploadTokenForEventLogo from "./getUploadTokenForEventLogo";
import getUploadTokenForEventPhoto from "./getUploadTokenForEventPhoto";
import getUploadTokenForNewsCover from "./getUploadTokenForNewsCover";
import getUploadTokenForNewsPhoto from "./getUploadTokenForNewsPhoto";
import getUploadTokenForProfilePhoto from "./getUploadTokenForProfilePhoto";
import getUploadTokenForSubEventCover from "./getUploadTokenForSubEventCover";
import getUploadTokenForSubEventLogo from "./getUploadTokenForSubEventLogo";
import getUploadTokenForSubEventPhoto from "./getUploadTokenForSubEventPhoto";
import getUploadTokenForUserProfilePhoto from "./getUploadTokenForUserProfilePhoto";
import getUserForAdmin from "./getUserForAdmin";
import logout from "./logout";
import markContactFormAsRead from "./markContactFormAsRead";
import me from "./me";
import refreshToken from "./refreshToken";
import registerUser from "./registerUser";
import rejectAccountDeletionRequest from "./rejectAccountDeletionRequest";
import rejectCommercialOpportunityRequest from "./rejectCommercialOpportunityRequest";
import rejectCompanyUpdateRequest from "./rejectCompanyUpdateRequest";
import rejectProfileUpdateRequest from "./rejectProfileUpdateRequest";
import removeSubEventPhoto from "./removeSubEventPhoto";
import resizeLegacyImages from "./resizeLegacyImages";
import resolveContactForm from "./resolveContactForm";
import sendCustomMail from "./sendCustomMail";
import sendCustomNotification from "./sendCustomNotification";
import sendPasswordResetLinkToUsers from "./sendPasswordResetLinkToUsers";
import shareAnnouncementOnInstagram from "./shareAnnouncementOnInstagram";
import shareNewsOnInstagram from "./shareNewsOnInstagram";
import startEvent from "./startEvent";
import startEventApplication from "./startEventApplication";
import switchOrganization from "./switchOrganization";
import threeTAddParticipantManually from "./threeTAddParticipantManually";
import threeTFinish from "./threeTFinish";
import threeTGenerateSeatingPlan from "./threeTGenerateSeatingPlan";
import threeTGetEventRound from "./threeTGetEventRound";
import threeTGetParticipantsForAdmin from "./threeTGetParticipantsForAdmin";
import threeTStartRound from "./threeTStartRound";
import toggleFormStatusForAdmin from "./toggleFormStatusForAdmin";
import updateAnnouncement from "./updateAnnouncement";
import updateBoardMember from "./updateBoardMember";
import updateCompanyForAdmin from "./updateCompanyForAdmin";
import updateDriveFile from "./updateDriveFile";
import updateDriveFolder from "./updateDriveFolder";
import updateGenericInfo from "./updateGenericInfo";
import updateNews from "./updateNews";
import updateNewsCategory from "./updateNewsCategory";
import updateOldPresident from "./updateOldPresident";
import updatePresident from "./updatePresident";
import updateProfile from "./updateProfile";
import updateSystemLocale from "./updateSystemLocale";
import updateUser from "./updateUser";
import type {
    ActionResponseTypes,
    ActionRequestTypes,
    ActionsType
} from "../types";
export {
    default as batchCreateDriveFolderHierarchy
} from "./batchCreateDriveFolderHierarchy";
export {
    default as duplicateFormForAdmin
} from "./duplicateFormForAdmin";
export {
    default as resizeLegacyImages
} from "./resizeLegacyImages";
const actions: {
    [key in ActionsType]: (params: ActionRequestTypes[key]) => Promise<ActionResponseTypes[key]>
} = {
    getAllCommercialOpportunityRequestHistories,
    getAllAccountDeletionRequestHistories,
    approveCommercialOpportunityRequest,
    getAllCommercialOpportunityRequests,
    getAllCompanyUpdateRequestHistories,
    getAllProfileUpdateRequestHistories,
    getUploadTokenForAnnouncementCover,
    getUploadTokenForAnnouncementPhoto,
    rejectCommercialOpportunityRequest,
    getUploadTokenForUserProfilePhoto,
    batchCreateDriveFolderHierarchy,
    getCommercialOpportunityRequest,
    getUploadTokenForSubEventCover,
    getUploadTokenForSubEventPhoto,
    approveAccountDeletionRequest,
    getAllAccountDeletionRequests,
    getUploadTokenForCompanyPhoto,
    getUploadTokenForContentPhoto,
    getUploadTokenForProfilePhoto,
    getUploadTokenForSubEventLogo,
    threeTGetParticipantsForAdmin,
    rejectAccountDeletionRequest,
    sendPasswordResetLinkToUsers,
    shareAnnouncementOnInstagram,
    threeTAddParticipantManually,
    approveCompanyUpdateRequest,
    approveProfileUpdateRequest,
    getAllCompanyUpdateRequests,
    getAllProfileUpdateRequests,
    getUploadTokenForEventCover,
    getUploadTokenForEventPhoto,
    getUploadTokenForEventLogo,
    getUploadTokenForNewsCover,
    getUploadTokenForNewsPhoto,
    rejectCompanyUpdateRequest,
    rejectProfileUpdateRequest,
    threeTGenerateSeatingPlan,
    toggleFormStatusForAdmin,
    getAllCompaniesForAdmin,
    getAllSentNotifications,
    getAllSubEventsForAdmin,
    getCompanyUpdateRequest,
    getProfileUpdateRequest,
    getSentNotificationById,
    deleteSentNotification,
    getFormAnswersForAdmin,
    getUploadTokenForDrive,
    sendCustomNotification,
    createCompanyForAdmin,
    duplicateFormForAdmin,
    markContactFormAsRead,
    startEventApplication,
    updateCompanyForAdmin,
    getAllEventsForAdmin,
    getAllNewsCategories,
    getDashboardOverview,
    shareNewsOnInstagram,
    endEventApplication,
    getAllAnnouncements,
    getAllFormsForAdmin,
    getAllOldPresidents,
    getAllSystemLocales,
    getAllUsersForAdmin,
    getAnnouncementById,
    getGenericInfoByKey,
    getSubEventForAdmin,
    removeSubEventPhoto,
    threeTGetEventRound,
    createAnnouncement,
    createNewsCategory,
    createOldPresident,
    createSystemLocale,
    deleteAnnouncement,
    deleteNewsCategory,
    deleteOldPresident,
    deleteSystemLocale,
    getAllBoardMembers,
    getAllContactForms,
    getAllDriveFolders,
    getCompanyForAdmin,
    resizeLegacyImages,
    resolveContactForm,
    switchOrganization,
    updateAnnouncement,
    updateNewsCategory,
    updateOldPresident,
    updateSystemLocale,
    createBoardMember,
    createDriveFolder,
    createDriveRecord,
    deleteBoardMember,
    deleteContactForm,
    deleteDriveFolder,
    getAllGenericInfo,
    getInitialConfigs,
    updateBoardMember,
    updateDriveFolder,
    updateGenericInfo,
    getAllDriveFiles,
    getEventForAdmin,
    threeTStartRound,
    deleteDriveFile,
    getAllSentMails,
    getFormForAdmin,
    getSentMailById,
    getUniversities,
    getUserForAdmin,
    updateDriveFile,
    updatePresident,
    cancelSubEvent,
    changePassword,
    createSubEvent,
    deleteSubEvent,
    executeCommand,
    getDepartments,
    sendCustomMail,
    getDriveItems,
    updateProfile,
    checkVersion,
    editSubEvent,
    getDistricts,
    getFaculties,
    getPositions,
    getPresident,
    refreshToken,
    registerUser,
    threeTFinish,
    createEvent,
    deleteEvent,
    finishEvent,
    getNewsById,
    adminLogin,
    changeMail,
    createForm,
    createNews,
    deleteForm,
    deleteNews,
    deleteUser,
    getAllNews,
    getProfile,
    getSectors,
    startEvent,
    updateNews,
    updateUser,
    editEvent,
    getCities,
    editForm,
    logout,
    me
};
export default actions;
